<template>
  <div class="emap-flow-modal-delAssignee">
    <van-popup v-model="visible" position="bottom" get-container="body" :style="{ width: '100%'}">
      <atom-select
        v-model="taskId"
        label="节点"
        type="picker"
        :options="nodeList"
        label-key="nodeName"
        value-key="taskId"
        :disabled="nodeList.length == 1"
        @confirm="nodeChange"
      ></atom-select>
      <div class="emap-flow-assignee">
        <label class="emap-flow-assignee-label">处理人</label>
        <div class="emap-flow-assignee-content">
          <van-tag 
            plain 
            :closeable="canDelete"
            type="primary" 
            v-for="(item, index) in assigneesObj" 
            :key="item.userId" 
            @close="deleteAssignee(item, index)" 
            class="emap-flow-tag"
          >{{item.userName}}</van-tag>
        </div>
      </div>
      <div class="emap-flow-assignee">
        <label class="emap-flow-assignee-label">处理组</label>
        <div class="emap-flow-assignee-content">
          <van-tag 
            plain 
            :closeable="canDelete"
            type="primary" 
            v-for="(item, index) in groups" 
            :key="item.groupId" 
            @close="deleteGroup(item, index)" 
            class="emap-flow-tag"
          >{{item.groupName}}</van-tag>
        </div>
      </div>
      <van-row>
        <van-col span="12">
          <van-button block square @click="visible = false">取消</van-button>
        </van-col>
        <van-col span="12">
          <van-button type="info" block square @click="onConfirm">确定</van-button>
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
  import { AtomSelect } from "../atomic"
  import { getAddOrDelAssignee } from '@/api/toolbar'

  export default {
    name: "del-asssignee",
    components: {
      AtomSelect
    },
    data() {
      return {
        visible: false,
        nodeList: [],
        taskId: "",
        hasMultiInstance: false,
        assigneesObj: [],
        groups: [],
        deleteAssignees: []
      }
    },
    props: {
      value: Boolean,
      taskid: String,
      defkey: String
    },
    watch: {
      value(val) {
        this.visible = val;
        if(val) this.initDelAssignee();
      },
      visible(val) {
        if(!val) this.$emit('input', false);
      }
    },
    computed: {
      canDelete() {
        return (this.groups.length + this.assigneesObj.length) > 1
      }
    },
    methods: {
      initDelAssignee() {
        this.clearVariables()
        getAddOrDelAssignee({
          "taskId": this.taskid, 
          "defKey": this.defkey
        }).then(data => {
          if(data && data.items){
            this.nodeList = data.items;
            if(this.nodeList.length === 1) {
              this.taskId = this.nodeList[0].taskId
              this.assigneesObj = JSON.parse(JSON.stringify(this.nodeList[0].assigneesObj))

              let keys = Object.keys(this.nodeList[0]);
              if(keys.includes("candidateGroups")) {
                this.hasMultiInstance = true
                this.groups = this.nodeList[0].candidateGroupsObj.map(opt => {
                  opt.groupId = "group(" + opt.groupId + ")"
                  return opt
                })
              }
            }
          }
        })
      },
      clearVariables() {
        this.hasMultiInstance = false
        this.nodeList = []
        this.taskId = ""
        this.assigneesObj = []
        this.groups = []
        this.deleteAssignees = []
      },
      nodeChange(item) {
        this.deleteAssignees = []
        this.assigneesObj = JSON.parse(JSON.stringify(item.assigneesObj))

        let keys = Object.keys(item)
        if(keys.includes("candidateGroups")) {
          this.groups = item.candidateGroupsObj.map(opt => {
            opt.groupId = "group(" + opt.groupId + ")"
            return opt
          })
        }
      },
      deleteAssignee(item, index) {
        this.deleteAssignees.push(item.userId)
        this.assigneesObj.splice(index, 1)
      },
      deleteGroup(item, index) {
        this.deleteAssignees.push(item.groupId)
        this.groups.splice(index, 1)
      },
      onConfirm() {
        if(!this.taskId) {
          this.$Message.warning("请选择节点")
          return
        }

        if(!this.deleteAssignees.length){
          this.$Message.warning("节点下处理人/组无变更");
          return
        }
        this.$emit('on-confirm', this.taskId, this.deleteAssignees.join(','))
        this.visible = false
      }
    }
  };
</script>

<style scoped>
  .emap-flow-assignee {
    padding: 0 17px;
  }
  .emap-flow-assignee-label {
    float: left;
    width: 84px;
    padding: 8px 0;
  }
  .emap-flow-assignee-content {
    margin-left: 84px;
    height: 160px;
    overflow-y: auto;
    padding: 4px 0 10px;
  }
  .emap-flow-tag {
    margin: 2px 4px 2px 0;
  }
  .emap-flow-pick-m>>>.tree-mask {
    z-index: 9999;
  }
</style>